import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingImageChange } from 'services/setting'
import posthog from 'posthog-js'

export default function useEditInfo(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISettingImagePayload) => {
            return settingImageChange(payload)
        },
        onSuccess: (data) => {
            toast.success('مشخصات صندوق با موفقیت تغییر یافت')
            refetch()
        },
        onError: (error: any, variables: any) => {
            posthog.capture('fund_setting_save_failed', {
                section: 'info',
                fund_id: variables?.id,
                status: error?.response?.status,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { isLoading, mutate }
}
